module.exports = __webpack_public_path__ + "img/bottomCode.a6bffb6e.png";